// Wordmark — custom-drawn, NOT the Inter Tight default. A solid, financial-feeling mark.
// Ported from yeni-design/src/shell.jsx (lines 4-25).

type WordmarkSize = 'sm' | 'md' | 'lg';

interface WordmarkProps {
  size?: WordmarkSize;
  className?: string;
}

export function Wordmark({ size = 'md', className = '' }: WordmarkProps) {
  const sizes: Record<WordmarkSize, { mark: number; text: string }> = {
    sm: { mark: 22, text: 'text-[14px]' },
    md: { mark: 28, text: 'text-[16px]' },
    lg: { mark: 36, text: 'text-[22px]' },
  };
  const s = sizes[size];
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/raporgor-logo.png?v=2"
        alt=""
        width={s.mark}
        height={s.mark}
        className="object-contain shrink-0"
      />
      <span className={`${s.text} font-semibold tracking-tight text-ink-900`}>
        Rapor<span className="text-brand-700">Gör</span>
      </span>
    </div>
  );
}
